import { render } from "./BancoCreate.vue?vue&type=template&id=98ada20c&scoped=true"
import script from "./BancoCreate.vue?vue&type=script&lang=js"
export * from "./BancoCreate.vue?vue&type=script&lang=js"

import "./BancoCreate.vue?vue&type=style&index=0&id=98ada20c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ada20c"]])

export default __exports__